/* unplugin-vue-components disabled */import { render } from "./NumberAnimation.vue?vue&type=template&id=e0de56b6&ts=true"
import script from "./NumberAnimation.vue?vue&type=script&lang=ts"
export * from "./NumberAnimation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__